import React from 'react';
import { useTranslation } from 'react-i18next';
import { isVerified } from '@redux/selectors/profile';
import { useSelector } from 'react-redux';

export default () => {
  const { t } = useTranslation();
  const is_verified = useSelector((s) => isVerified(s));

  return (
    <div className="flex-center w-100 flex-column" style={{ color: '#707070', fontSize: '1.5em' }}>
      <h3 className="font-weight-bold">{t('not_found.title')}</h3>
      {!is_verified && <div className="text-danger">Status: Not Approved</div>}
      {!is_verified && <div>Please contact admin to approve your access</div>}
      <div>{t('not_found.message')}</div>
    </div>
  );
};
